import React, { useEffect, useState } from 'react';
import DashboardPagesTemplate from '../../../components/DashboardPagesTemplate/DashboardPagesTemplate';
import { ColumnBalanceHistory, BalanceHistoryData } from '../../../types/TablesTypes/balanceHistory';
import client from '../../../api/client';
import showToast from '../../../components/CustomToast/toastHelper';
import moment, { Moment } from 'moment';
import { numberWithCommas } from '../../../utils/formatNumber';
import StatusView from '../../../components/StatusView/StatusView';
import { Dropdown } from 'flowbite-react';
import { FaEllipsisH } from 'react-icons/fa';
import { useCurrency } from '../../../contexts/CurrencyContext';

const BalanceHistory = () => {
    const {currency} = useCurrency()
    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: "",
        currency: currency ,
        status: "",
        direction:""
    });

    const [bearer, setBearer] = useState<boolean>(false);
    const [history, setHistory] = useState<any>(null);
    const [tableRow, setTableRow] = useState<BalanceHistoryData[]>([]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(1);
    const [loading, setLoading] = useState<boolean>(true);
    const [isExport, setIsExport] = useState<boolean>(false)
    const [isExportReady, setIsExportReady] = useState<boolean>(false); 
    const [isExportLoading, setIsExportLoading] = useState<boolean>(false);

    const clickExport = async () => {
        setIsExport(true);
        setIsExportLoading(true)
        await fetchHistory(); 
    
        if (history && history.items?.length > 0) {
            setIsExportReady(true); 
        }
    
        setIsExportLoading(false); 
    };


    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)
            await fetchHistory();
            setLoading(false)
        };
        fetchData();
    }, [filters, currency]);

    const fetchHistory = async () => {
        try {
            const mappedFilters = {
                ...filters,
                direction: filters.direction === "Debit" ? "D" : filters.direction === "Credit" ? "C" : "",
            };
            const apiUrl = '/subsidiary/dashboard/fetch/wallet/history';
            const params = new URLSearchParams(
                mappedFilters
            ).toString();
            const response = await client.get(`${apiUrl}?${params}`);

            setHistory(response.data.data);
            setTotalPages(response.data.data.page.totalPage);
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('Error getting data', err);
                showToast(message, "error");
            }
        }
    };

    useEffect(() => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            currency: currency,
        }));
    }, [currency]);


    const dataHistory = () => {
        const tempArr: BalanceHistoryData[] = [];
        history?.items
            ?.slice(0)
            .reverse()
            .forEach((balance: any, index: number) => {
                tempArr.push({
                    date: (moment.utc(balance?.dateCreated).local() as Moment).format('MMMM Do YYYY, h:mm a'),
                    amount: `${currency} ${numberWithCommas(balance?.amount)}`,
                    direction: (
                        <StatusView
                            status={balance?.direction}
                            green={'Credit'}
                            red={'Debit'}
                        />
                    ),
                    balance: `${currency} ${numberWithCommas(balance?.balance)}`,
                    details: balance?.remarks,
                    action: (
                        <Dropdown label={<FaEllipsisH />} inline arrowIcon={false} placement='right-start'>
                            {/* Add dropdown items here */}
                        </Dropdown>
                    ),
                });
            });
        return tempArr;
    };

    useEffect(()=>{
        setTableRow(dataHistory());

    },[history?.items])


    return (
        <div>
            <DashboardPagesTemplate
                title='Balance History'
                onFilterChange={setFilters}
                dataToExport={isExportReady ? history?.items : []}
                apiUrl=''
                ctaButtonExists={false}
                exportButtonExists={true}
                dropdownItems={["All","Debit","Credit"]}
                data={tableRow}
                showSearch={true}
                buttonIcon=''
                buttonLabel=''
                headings={ColumnBalanceHistory}
                filters={filters}
                emptyMessage={`You currently do not have any balance history in ${currency}`}
                statusKey='direction'
                loading={loading}
                clickExportButton={clickExport}
                exportButtonLoading={isExportLoading}
                exportButtonClicked={isExport}
            />
        </div>
    );
};

export default BalanceHistory;
